import React, {Component} from "react";
import InfoPopupComponent from "./InfoPopupComponent";

const handleClick = () => {
    // Open URL in a new tab
    window.open('/open_data/tentang', '_blank');
}

export class AboutComponent extends Component{
    render(){
        return(
            <section id="hero" className="d-flex align-items-center">
                <InfoPopupComponent />
                
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 d-lg-flex flex-lg-column justify-content-center align-items-stretch pt-5 pt-lg-0 order-2 order-lg-1" data-aos="fade-up">
                            <div>
                                <h1>Portal Satu Data</h1>
                                <h1 className="font-weight-100">
                                Pemerintah Kabupaten Sampang
                                </h1><br/>
                                <h2>Merupakan portal yang menyediakan data tentang <b>Kabupaten Sampang</b> yang berkualitas dan terbuka, serta memberikan kemudahan akses untuk publik dan instansi pemerintahan.</h2>
                                {/* <a href="#" onClick={handleClick} className="download-btn">Selengkapnya</a> */}
                            </div>
                        </div>
                        <div className="col-lg-6 d-lg-flex flex-lg-column align-items-stretch order-1 order-lg-2 hero-img" data-aos="fade-up">
                            <img src={`${process.env.PUBLIC_URL}/template/img/hero-img.png`} className="img-fluid" alt="" />
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default AboutComponent;